import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onFinish }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // Main timer - always finish after 2 seconds
    const timer = setTimeout(() => {
      onFinish();
    }, 2000);

    // Fallback timer - force finish after 4 seconds max (safety net)
    const fallbackTimer = setTimeout(() => {
      console.log('⚠️ SplashScreen fallback timer triggered');
      onFinish();
    }, 4000);

    return () => {
      clearTimeout(timer);
      clearTimeout(fallbackTimer);
    };
  }, [onFinish]);

  // Handle image load error - still show splash with text
  const handleImageError = () => {
    console.warn('⚠️ Logo image failed to load');
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div 
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      data-keep-dark=""
      style={{ 
        background: 'linear-gradient(180deg, #450050 0%, #e753fe 100%)',
        animation: 'fadeOut 0.5s ease-out 1.5s forwards'
      }}
    >
      <style>
        {`
          @keyframes fadeOut {
            from {
              opacity: 1;
            }
            to {
              opacity: 0;
            }
          }
          @keyframes logoAppear {
            from {
              opacity: 0;
              transform: translateY(20px) scale(0.9);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
          @keyframes textAppear {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.7;
            }
          }
          @keyframes loadingBar {
            0% {
              width: 0%;
            }
            100% {
              width: 100%;
            }
          }
        `}
      </style>
      
      {/* Logo centré */}
      <div 
        className="flex flex-col items-center"
        style={{ animation: 'logoAppear 0.8s ease-out' }}
      >
        {!imageError ? (
          <img 
            src="/destine-logo-complet.png" 
            alt="Destine" 
            className="w-72 h-auto mb-4"
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{ 
              opacity: imageLoaded ? 1 : 0,
              transition: 'opacity 0.3s ease',
              filter: 'drop-shadow(0 10px 30px rgba(0, 0, 0, 0.3))'
            }}
          />
        ) : (
          /* Fallback if image fails to load - show text logo */
          <div className="mb-4 text-center">
            <h1 
              className="text-5xl font-bold tracking-wider"
              style={{ 
                color: '#ffffff',
                textShadow: '0 0 20px rgba(255, 255, 255, 0.5)'
              }}
            >
              DESTINE
            </h1>
            <p className="text-white/70 text-sm mt-2">STUDIO</p>
          </div>
        )}
        
        {/* Loading bar */}
        <div 
          className="mt-8 w-48 h-1 bg-white/30 rounded-full overflow-hidden"
          style={{ animation: 'textAppear 0.8s ease-out 0.6s both' }}
        >
          <div 
            className="h-full bg-white rounded-full"
            style={{ 
              animation: 'loadingBar 1.8s ease-out forwards'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
